module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/backstage-module/components/attributes-select-add-bar/attributes-select-add-bar.component.scss
// module id = ./src/app/modules/backstage-module/components/attributes-select-add-bar/attributes-select-add-bar.component.scss
// module chunks = 9